import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { GetInvitationResolver } from '@modeso/aumico-lib-users-fe';
import { I18NextModule } from 'angular-i18next';
import { InvitationExpiredPage } from '../../components/invitation-expired/invitation-expired.component';
import { Paths } from '../../enums/paths.enum';
import { AcceptInvitationPage } from '../../pages/accept-invitation/accept-invitation.page';
import { BexioErrorPage } from '../../pages/bexio/bexio-error/bexio-error.page';
import { LoginPage } from '../../pages/login/login.page';
import { ResetPasswordPage } from '../../pages/passwords/reset-password/reset-password.page';
import { SetPasswordPage } from '../../pages/passwords/set-password/set-password.page';
import { ResetAccountPage } from '../../pages/reset/reset.page';
import { SignupPage } from '../../pages/signup-process';
import { ConfirmAccountPage } from '../../pages/signup-process/confirm-account/confirm-account.page';
import { NoAuthGuard } from '../../shared/noauth.guard';
import { AuthModulePage } from './auth-module.page';

// Import SSO components
import { AumicoComponentsModule } from '../../../../../aumico-components/src/lib';
import { SsoCallbackPageComponent } from '../../pages/sso/sso-callback/sso-callback.page';
import { SsoRedirectPageComponent } from '../../pages/sso/sso-redirect/sso-redirect.page';
import { MfaSetupPage } from '../../pages/mfa-setup/mfa-setup.page';
import { MfaVerifyPage } from '../../pages/mfa-verify/mfa-verify.page';

const routes: Routes = [
    {
        path: '',
        component: AuthModulePage,
        children: [
            { path: '', redirectTo: `${Paths.LOGIN}`, pathMatch: 'full' },
            {
                path: `${Paths.LOGIN}`,
                component: LoginPage,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'Login',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            {
                path: `${Paths.SIGNUP}`,
                component: SignupPage,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'Signup',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            {
                path: `${Paths.INVITATION_EXPIRED}`,
                component: InvitationExpiredPage,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'Signup',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            {
                path: `${Paths.INVITATION}`,
                component: AcceptInvitationPage,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'Signup',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
                resolve: {
                    invitation: GetInvitationResolver,
                },
            },

            {
                path: `${Paths.RESET}`,
                component: ResetAccountPage,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'Reset',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            {
                path: `${Paths.PASSWORD_RESET}`,
                data: {
                    label: 'Signup',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
                component: ResetPasswordPage,
                canActivate: [NoAuthGuard],
            },
            {
                path: `${Paths.EMAIL_VERIFICATION}`,
                data: {
                    label: 'Signup',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
                component: SetPasswordPage,
                canActivate: [NoAuthGuard],
            },
            {
                path: `${Paths.CONFIRM_ACCOUNT}`,
                component: ConfirmAccountPage,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'Signup',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            {
                path: `${Paths.RESET_INSTRUCTIONS}`,
                component: ConfirmAccountPage,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'Signup',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            {
                path: `${Paths.BEXIO_ERROR}`,
                component: BexioErrorPage,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'BexioError',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            // SSO Routes
            {
                path: 'sso/:handle',
                component: SsoRedirectPageComponent,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'SSO Redirect',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            {
                path: 'sso/:handle/callback',
                component: SsoCallbackPageComponent,
                canActivate: [NoAuthGuard],
                data: {
                    label: 'SSO Callback',
                    canSeeNavigationLinkRoles: ['UNDEFINED'],
                    icon: 'logout',
                },
            },
            {
                path: '2fa/setup',
                component: MfaSetupPage,
                data: { label: 'MFA Setup', canSeeNavigationLinkRoles: ['UNDEFINED'] },
            },
            {
                path: '2fa/verify',
                component: MfaVerifyPage,
                data: { label: 'MFA Verify', canSeeNavigationLinkRoles: ['UNDEFINED'] },
            },
            {
                path: '',
                redirectTo: `${Paths.LOGIN}`,
                pathMatch: 'full',
            },
            {
                path: '**',
                redirectTo: `${Paths.LOGIN}`,
                pathMatch: 'full',
            },
        ],
    },
];

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, AumicoComponentsModule, I18NextModule, RouterModule.forChild(routes)],
    declarations: [SsoCallbackPageComponent, SsoRedirectPageComponent, MfaSetupPage, MfaVerifyPage],
})
export class AuthModule { }
